import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCatalogGrades } from "../../../repositories/CatalogGradeRepository";
import { TableGrade } from "../components/TableGrade";
import { useCatalogGradeContext } from "../context/CatalogGradeContext";
type Props = {};

export const CatalogGradePage = (props: Props) => {
  const { actions } = useCatalogGradeContext();
  const { gradeId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const getCatalogGradesFromAPI = async () => {
    setIsLoading(true);
    const resp = await getCatalogGrades();
    if (resp.ok) {
      const grades = get(resp, "data.tables[0].rows", []);
      actions.setGrades(grades);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getCatalogGradesFromAPI();
  }, []);

  return (
    <>
      <HelmetDexteel title={"Grades"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableGrade
              gradeId={gradeId}
              isLoading={isLoading}
              getCatalogGradesFromAPI={getCatalogGradesFromAPI}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
